import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { Tax } from '@app/shared/models/tax';
import { TaxService } from '@app/shared/services/taxes/tax.service';
import { Observable } from 'rxjs';

@Component({
  standalone: false,
  selector: 'sbnb-add-tax-review',
  templateUrl: './add-tax-review.component.html',
  styleUrls: ['./add-tax-review.component.scss'],
})
export class AddTaxReviewComponent implements OnInit {
  tax: Tax = null;
  @Input() tax$: Observable<Tax>;
  @Output() complete: EventEmitter<string> = new EventEmitter();

  saving: boolean = false;

  constructor(
    private router: Router,
    public taxService: TaxService
  ) { }

  ngOnInit(): void {
    this.tax$.subscribe((tax) => {
      this.tax = tax;
    });
  }

  progress() {
    this.saving = true;

    if (this.tax.uuid) {
      this.updateExistingTax();
    } else {
      this.createNewTax();
    }
  }

  createNewTax() {
    this.taxService.createTax(this.tax).subscribe(
      (res) => {
        if (res.uuid) {
          this.taxService.addPropertiesToTax(res.uuid, this.tax.properties).subscribe((res) => {
            this.saving = false;
            this.complete.emit('done');
          });
        }
      },
      (err) => {
        this.saving = false;
      }
    );
  }

  updateExistingTax() {
    this.taxService.updateTax(this.tax.uuid, this.tax).subscribe(
      (res) => {
        this.saving = false;
        this.taxService.addPropertiesToTax(this.tax.uuid, this.tax.properties).subscribe((res) => {
          this.saving = false;

          this.complete.emit('done');
        });
      },
      (err) => {
        this.saving = false;
      }
    );
  }

  back() {
    this.complete.emit('scope');
  }
}
